import { type Hyperlink } from '@databases/types/database';

/**
 * Returns whether every URL uses a supported HTTP(S) or valid mailto scheme.
 */
export function isValidHyperlinkUrl(urls: string | string[]): boolean {
  const values = typeof urls === 'string' ? [urls] : urls;

  return values.every((url) => {
    try {
      new URL(url);
      const urlPattern = /^(https?:\/\/)/;
      const mailtoPattern = /^mailto:(.+)/;

      if (urlPattern.test(url)) {
        return true;
      }

      const matchResult = url.match(mailtoPattern);
      if (!matchResult) {
        return false;
      }

      const [, email] = matchResult;
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

      return emailPattern.test(email);
    } catch {
      return false;
    }
  });
}

/**
 * Adds an HTTPS scheme to a non-empty hyperlink URL when one is absent.
 */
export function makeValidHyperlink(value: Hyperlink): Hyperlink {
  if (value.url && !isValidHyperlinkUrl(value.url)) {
    return { ...value, url: `https://${value.url}` };
  }

  return value;
}
